angular.module('bbl.directives.ng-autofocus', [])
.directive('ngAutofocus', [function() {
	return {
		restrict: 'EA',
		link: function($scope, $el) {
			setTimeout(function() {
        $el.focus();
      });
		}
	};
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/ng-autofocus.js
 ** module id = 172
 ** module chunks = 0
 **/